<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ju59JZ/tc-custom/cover_9781476771526.jpg?1718183632435?1730539223336" alt="This image is the cover for the book Spider, Elemental Assassin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spider, Elemental Assassin
      </h1>
      <p class="bookDescription body article font2">
        <b>The full origin story of Gin Blanco’s transformation into the fearsome assassin known as the Spider—from the bestselling author of <i>Heart of Venom</i>.</b><br/><br/>How did I end up in a career where I always have blood on my hands? Well, let me tell you a story about an assassin who thought she could do no wrong . . . <br/><br/>Ten years ago. A blistering hot August night. I remember like it was yesterday. The night I, Gin Blanco, truly became the Spider. Killing people is what I do best, especially now that I’ve honed my Ice and Stone magic. But back then, I had yet to learn one very important rule: arrogance will get you, every single time.<br/><br/>This particular job seemed simple: murder a crooked building contractor with ties to ruthless Fire elemental Mab Monroe. My mentor, Fletcher Lane, had some misgivings, but I was certain that I had the situation under control . . . right up until I exposed my weaknesses to a merciless opponent who exploited every single one of them. There’s a reason assassins aren’t supposed to feel anything. Luckily, a knife to the heart can fix that problem, especially when I’m the one wielding it . . .<br/><br/><b>“An amazing ride . . . <i>The Spider</i> made me fall in love with Gin all over again.” —<i>All Things Urban Fantasy</i></b><br/><br/><b>“Estep did a great job of having a younger, more naïve, and a less patient Gin come across the page.” —<i>Vampire Book Club</i></b><br/><br/><b>“I was tremendously satisfied and as anxious as ever for more from Ashland’s greatest (semi-retired) assassin.” —<i>Smexy Books</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Estep
      </h2>
      
      <p class="authorDescription body article">Jennifer Estep is a <I>New York Times </I>and <I>USA Today </I>bestselling author prowling the streets of her imagination in search of her next fantasy idea. <I>Spider&rsquo;s Bite, Web of Lies, Venom, Tangled Threads,</I><I>Spider&rsquo;s Revenge, By a Thread, Widow&rsquo;s Web, Deadly Sting, Heart of Venom</I>, <I>The Spider, Poison Promise, Black Widow, Spider&rsquo;s Trap, Bitter Bite, Unraveled, </I>and <I>Snared, </I>along with the e-shorts <I>Thread of Death, Parlor Tricks, Kiss of Venom</I>, <I>Unwanted, </I>and<I> Nice Guys Bite</I> are the other works in her red-hot Elemental Assassin<B></B>urban fantasy series. Jennifer is also the author of the Black Blade and Mythos Academy young adult urban fantasy series and the Bigtime<B></B>paranormal romance series. For more on Jennifer and her books, visit her at JenniferEstep.com and @Jennifer_Estep.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71357460